import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import ButtonLarge from 'common/ButtonLarge';
import HeadingHome from 'common/HeadingHome';

import backgroundPricing from '../../../common/Images/Home/backgroundPricing.png';

import { HomePageIds } from 'common/constant';
import { useNavigate } from 'react-router-dom';
import routes from 'config/routes';

const AffordablePrice = () => {
    const Heading = ({ children, color = '#999' }) => {
        return <span className={`text-[${color}] text-center font-bold text-[28px] font-poppins`}>{children} </span>;
    };
    const SubText = ({ children }) => {
        return (
                            <span className="pb-8 border-solid border-b-[1px] border-[#E1E1E1] text-[16px] font-normal text-[#333] text-center font-poppins">
                {children}
            </span>
        );
    };
    const focusAreas = ['Collections & denials', 'Administrative overhead', 'Insurance network oversight'];
    const beSeenQualities = [
        'No setup or subscription fees',
        'Instant, secure payments',
        'No insurance hassle',
    ];

    const navigate = useNavigate()

    return (
        <div className="flex flex-col items-center py-[80px] px-8 md:pt-[140px] md:px-12 md:pb-[140px] lg:pt-[140px] lg:pb-[140px] lg:px-16 xl:pt-[140px] xl:pb-[140px] xl:px-24 bg-[#F5F1ED] font-['Poppins'] gap-14" id={HomePageIds.pricing}>
            <HeadingHome className="text-center lg:w-[80%] xl:w-[60%] max-w-[545px]">Providing proper care has a very affordable price!</HeadingHome>
            <div className="flex flex-col md:flex-row gap-12 w-full md:w-[90%] lg:w-[70%] xl:w-[900px] justify-center items-center md:items-start">
                <div className="flex flex-col bg-white rounded-3xl py-10 px-4 lg:px-6 xl:px-8 items-center w-[400px] max-w-full md:w-[362px] h-fit">
                        <div className="flex flex-col w-[70%] text-[#999] items-center gap-2 ">
                            <Heading>Typical Cost Of Medical Billing </Heading>
                            <span className="font-normal text-[112px] font-['Abril_Fatface'] opacity-90 leading-none">
                                31.99
                                <Heading>%</Heading>{' '}
                            </span>
                            <span className="font-normal text-[14px]">of every $100 in revenue </span>
                        </div>

                    <div className="flex flex-col pt-10">
    <SubText className="text-gray-500 text-center font-poppins">
        Providers spend up to 32% of revenue on billing services such as filing insurance claims,
        billing patients, collecting overdue payments, and dealing with denials or audits.
    </SubText>

    <div className="pt-8 text-center font-poppins" style={{ color: 'rgba(153, 153, 153, 1)' }}>
    Hidden costs such as <strong>claim denials</strong>, <strong>administrative delays</strong>, and <strong>collection fees</strong> often make traditional billing unpredictable and expensive.
</div>

</div>

                </div>

                <div className="flex flex-col bg-white rounded-3xl items-center w-[400px] max-w-full md:w-[458px] shadow-lg">

                        <div
                            className="flex flex-col w-[70%] text-white items-center gap-2 rounded-t-3xl bg-cover bg-center bg-white px-16 pb-32 pt-8 w-full h-[450px]"
                            style={{
                                backgroundImage: `url(${backgroundPricing})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center 30%',
                                backgroundSize: 'cover',
                            }}
                        >
  <Heading color="white">
    BeSeen Pricing - <span className="whitespace-nowrap font-poppins text-[28px]">Simple & Transparent</span>
  </Heading>
                               <span className="font-normal text-[14px] mt-3">As low as </span>

  {/* Wrapped price and 'per transaction' together */}
  <div className="flex flex-col items-center leading-none">
    <span className="font-normal text-[112px] font-['Abril_Fatface'] text-white">
      5.99
      <Heading color={'#FFF'}>%</Heading>
    </span>
    <span className="font-normal text-[14px] mt-2">introductory rate per transaction</span>
  </div>
</div>

                        <div className="flex flex-col pb-10 px-4 lg:px-6 xl:px-8">
                            <span className="pb-4 text-[16px] font-normal text-[#333] text-center font-poppins">
                                Lower fees as transaction amounts increase.
                            </span>

  {/* Pricing Table */}
  <div className="w-full flex justify-center pt-4 pb-6 font-poppins">
    <table className="w-full max-w-[305px] text-left border-collapse">
      <tbody>
        {[
          { range: '$0 - $250', fee: '14.99%' },
          { range: '$250.01 - $500', fee: '12.99%' },
          { range: '$500.01 - $750', fee: '9.99%' },
          { range: '$750.01 - $1,000', fee: '7.99%' },
          { range: '$1,000.01+', fee: '5.99%', highlight: true },
        ].map(({ range, fee, highlight }, index) => (
          <tr
          key={index}
          className={`${highlight ? 'text-green-600 font-semibold' : 'text-gray-800'}`}
          style={highlight ? { color:"rgba(117, 189, 47, 1)" } : {}}
        >
        
            <td className="py-2 font-semibold text-[16px]">{range}</td>
            <td className="py-2 text-center text-gray-400 text-[16px]">→</td>
            <td className="py-2 text-right text-[16px]">{fee}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Full-width divider with equal spacing */}
  <div className="w-full border-b border-gray-200"></div>

  <div className="flex flex-col gap-7 px-3 py-8 max-w-[305px] mx-auto">
    {beSeenQualities.map((point, index) => (
      <div className="flex gap-4" key={index}>
        <DoneIcon
          style={{
            color: 'rgba(53, 139, 9, 1)',
            fontSize: '1.5rem',
            stroke: 'rgba(53, 139, 9, 1)',
            strokeWidth: 2,
          }}
        />
                                            <span className="text-[16px] font-normal color-[#333]">{point}</span>
      </div>
    ))}
  </div>

  {/* Full-width divider below checkmark list */}
  <div className="w-full border-b border-gray-200"></div>

  <div className="flex flex-col gap-8 pt-8">
    <ButtonLarge onClick={() => navigate(routes.auth.register)}>
      Start for Free – Get Paid Directly
    </ButtonLarge>
                                   <span className='text-[12px] font-normal text-[#999] text-center max-w-[305px] mx-auto'>
      No credit card or payment source needed to sign up and start using.
    </span>
  </div>
</div>

</div>

            </div>
        </div>
    );
};
export default AffordablePrice;
